import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=71b5bb32&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=71b5bb32&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b5bb32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b5bb32')) {
      api.createRecord('71b5bb32', component.options)
    } else {
      api.reload('71b5bb32', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=71b5bb32&scoped=true", function () {
      api.rerender('71b5bb32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goods/detail.vue"
export default component.exports